<template>
    <!--    底部组件-->
    <div class="footerBottom">
        <div class="content mainBox">
            <!--            文字信息-->
            <div class="content-text">
                <div class="linkText">
                    <router-link :to="{name:'PrivacyAgreement'}">隐私声明</router-link>
                    <router-link :to="{name:'UserAgreement'}">网页条款</router-link>
                    <router-link :to="{name:'ContactUs'}">联系我们</router-link>
                    <span class="third-links">
                      友情链接
                    <a class="tlink" target="_blank" href="https://qfpt.linping.gov.cn:8081" >
                      临平区企业服务平台
                    </a>
                    </span>
                </div>
                <p class="fontText"><img :src="telImg" alt="tel">电话：{{tel}} <img :src="addressImg" alt="address">地址：{{address}}</p>
                <p>
                    <img :src="anwangImg" alt="an" style="margin-right: 2px!important;">
                    <a class="imgAB" target="_blank" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${record}`" >
                    浙公网安备 {{record}}号
                    </a>
                    | 技术支持：浙江菜根科技产业发展有限公司
                </p>
                <p>
                    Copyright©2015-2021 浙江菜根科技产业发展有限公司 , All Rights Reserved
                    <a class="imgAB" target="_blank" href="https://beian.miit.gov.cn" >
                    {{support}}
                    </a>
                </p>
            </div>
            <!--二维码-->
            <div class="content-qrcode">
                <div v-if='appImg'>
                    <img :src="appImg" alt="APP">
                    <p>APP</p>
                </div>
                <!-- <div>
                    <img :src="publicImg" alt="公众号">
                    <p>公众号</p>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "lp-Footer",
        data(){
            return{
                telImg: '',
                addressImg: '',
                anwangImg:'',
                appImg:'',
                publicImg:'',
                tel:'',
                address:'',
                record:'',
                support:''
            }
        },
        created() {
             this.telImg=require('../../assets/images/telicon.png');
             this.addressImg=require('../../assets/images/addressicon.png');
             this.anwangImg=require('../../assets/images/batp.png');

             this.tel=localStorage.getItem('park_tel');
             this.address=localStorage.getItem('park_address');
             if(localStorage.getItem('park_appqrcodeImg')){//有些园区没有二维码
                this.appImg=require(`../../assets/images/${localStorage.getItem('park_appqrcodeImg')}`);
             }
             this.record=localStorage.getItem('park_record');
             this.support=localStorage.getItem('park_support');

            //  this.publicImg=require('../../assets/images/appqrcode.png')
        },

    }
</script>


<style lang="less" scoped>
    /*@import "~@/assets/base.less";*/
    .imgAB{
        color: #FFFFFF;
        text-decoration: none;
    }
    .imgAB:hover{
        color: #FFFFFF;
        text-decoration: underline;
    }
    .footerBottom{
        background-color: @backBlackColor;
        width: 100%;
        height: 228px;
        @qrcodeHeight:130px;//右侧模块高度
        @qrcodeWidth:100px;//右侧模块宽度,240px
        .content{
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;


            /*左侧文字信息*/
            .content-text{
                height: @qrcodeHeight;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .third-links {
                  color: #ddd;
                  font-size: 12px;
                  padding-left: 40px;
                  border-left: 1px solid #5e5e5e;
                  .tlink {
                    margin-left: 10px;
                    padding: 6px 10px;
                    background-color: #282828;
                  }
                }
                img:nth-child(2){
                    width: 11px;
                    height: 15px;
                    margin-left: 42px;
                }
                img{
                    width: 12px;
                    height: 12px;
                    margin-right: 6px;
                }
                .fontText{
                     display: flex;
                     align-items: center;
                     font-size: 12px;
                }
                p{

                    opacity: 0.45;
                    font-family: MicrosoftYaHeiUI;
                    font-size: 12px;
                    color: #FFFFFF;
                    padding: 0;
                    margin-bottom: 19px;
                }
                /*链接文字*/
                .linkText{
                    margin-bottom: 40px;
                    a{
                        margin-right: 40px;
                        opacity: 0.85;
                        font-family: MicrosoftYaHeiUI;
                        font-size: 12px;
                        color: #FFFFFF;
                    }
                    a:hover{
                        text-decoration: underline;
                    }
                }
            }
            /*右侧二维码信息*/
            .content-qrcode{
                width: @qrcodeWidth;
                height:@qrcodeHeight;
                display: flex;
                justify-content: space-between;
                align-items: center;
                div{
                    text-align: center;
                    width: 100px;
                    height: 100%;
                    img{
                        width: 100px;
                        height: 100px;
                    }
                    p{
                        padding-top: 10px;
                        opacity: 0.65;
                        font-family: MicrosoftYaHeiUI;
                        font-size: 12px;
                        color: #FFFFFF;
                    }
                }

            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue